export function remoteSubmit(formId: string) {
  const form = document.getElementById(formId);
  if (form instanceof HTMLFormElement) {
    form.dispatchEvent(new Event('submit', { cancelable: true }));
  } else {
    console.warn(`cannot submit ${form} with ID ${formId} as its not a form`);
  }
}
